import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';

//images
import logo from './../../images/logo.png';

const Footer = () => {
	return (
		<Fragment>
			<footer className="site-footer">
				<div className="footer-top">
					<div className="container wow fadeIn" data-wow-delay="0.5s">
						<div className="row">
							<div className="col-xl-3 col-lg-6 col-md-6 col-sm-6 footer-col-4">
								<div className="widget widget_ftabout">
									<div className="footer-logo">
										<Link to={"/"}><img src={logo} alt="" /></Link>
									</div>
									<p>Fueling Young Minds for a Brighter Tomorrow!</p>
								</div>
							</div>
							<div className="col-xl-3 col-lg-6 col-md-6 col-sm-6 footer-col-4">
								<div className="widget widget_services border-0">
									<h5 className="footer-title">Information</h5>
									<ul className="list-2">
										<li><Link to={"/"}>Home</Link></li>
										<li><Link to={"/about-2"}>About </Link></li>
										{/* <li><Link to={"/faqs"}>Faq</Link></li> */}
										{/* <li><Link to={"/event"}>Event</Link></li> */}
										<li><Link to={"/teachers"}>Teachers</Link></li>
										<li><Link to={"/gallery"}>Gallery</Link></li>
										<li><Link to={"/classes"}>Classes</Link></li>
										<li><Link to={"/contact-us"}>Contact</Link></li>
									</ul>
								</div>
							</div>
							<div className="col-xl-3 col-lg-6 col-md-6 col-sm-12 footer-col-4">
								<div className="widget recent-posts-entry">
									<h5 className="footer-title">Recent Posts</h5>
									<div className="widget-post-bx">
										<div className="widget-post clearfix">
											{/* <div className="dlab-post-media"> <img src={Blog1} width="200" height="143" alt="" /> </div> */}
											<div className="dlab-post-info">
												<div className="dlab-post-header">
													<h6 className="post-title"><Link to={"#"}>Jishan Foda</Link></h6>
												</div>
												<div className="dlab-post-meta">
													<ul>
														<li className="post-author">+91 99791 95757</li>
														{/* <li className="post-comment"><i className="fa fa-comments"></i> 28</li> */}
													</ul>
												</div>
											</div>
										</div>
										<div className="widget-post clearfix">
											{/* <div className="dlab-post-media"> <img src={Blog2} width="200" height="143" alt="" /> </div> */}
											<div className="dlab-post-info">
												<div className="dlab-post-header">
													<h6 className="post-title"><Link to={"#"}>Arman Foda </Link></h6>
												</div>
												<div className="dlab-post-meta">
													<ul>
														<li className="post-author">+91 76005 55027</li>
														{/* <li className="post-comment"><i className="fa fa-comments"></i> 5</li> */}
													</ul>
												</div>
											</div>
										</div>
										<div className="widget-post clearfix">
											{/* <div className="dlab-post-media"> <img src={Blog2} width="200" height="143" alt="" /> </div> */}
											<div className="dlab-post-info">
												<div className="dlab-post-header">
													<h6 className="post-title"><Link to={"#"}>Sufiyan Mala</Link></h6>
												</div>
												<div className="dlab-post-meta">
													<ul>
														<li className="post-author">+91 99793 95444</li>
														{/* <li className="post-comment"><i className="fa fa-comments"></i> 5</li> */}
													</ul>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="col-xl-3 col-lg-6 col-md-6 col-sm-6 footer-col-4">
								<div className="widget widget_ftabout">
									<div className="footer-logo">
										<Link to={"/"}><img src={logo} alt="" /></Link>
									</div>
									<p>Every Child Matters, Every Dream Counts!</p>
								</div>
							</div>
							{/* <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12 footer-col-4 ">
								<div className="widget">
									<h5 className="footer-title">Newsletter</h5>
									<div className="subscribe-form m-b20">
										<form className="dzSubscribe" ref={form} onSubmit={sendEmail}>
											<div className="dzSubscribeMsg"></div>
											<div>
												<input name="dzEmail" required="required"  className="form-control" placeholder="Your Email Address" type="email" />
												<button name="submit" value="Submit" type="submit" className="btn btn-md radius-xl">Subscribe</button>
											</div>
										</form>
									</div>
								</div>
							</div> */}
						</div>
					</div>
				</div>
				<div className="footer-bottom">
					<div className="container">
						<div className="row">
							<div className="col-lg-6 col-md-12 col-sm-12 text-center text-md-start">
								<span>
									Copyright © {new Date().getFullYear()} BrightFuture
								</span>
								<span>
									{' '}Developed By{' '}
									<a
										href="https://www.cyphervie.com/"
										target="_blank"
										rel="noopener noreferrer"
										style={{
											color: '#007bff',
											fontWeight: '600',
											textDecoration: 'underline', // makes it visually like a link
											cursor: 'pointer'
										}}
									>
										Sufiyan Mala
									</a>
								</span>

							</div>
							<div className="col-lg-6 col-md-12 col-sm-12 text-center text-md-end">
								<ul className="list-inline">
									{/* <li><Link to={"#"} className="btn-link facebook circle me-1"><i className="fa fa-facebook"></i></Link></li>
									<li><Link to={"#"} className="btn-link google-plus circle me-1"><i className="fa fa-google-plus"></i></Link></li>
									<li><Link to={"#"} className="btn-link linkedin circle me-1"><i className="fa fa-linkedin"></i></Link></li> */}
									<li><Link to={"https://www.instagram.com/brightfuture_cu?igsh=MWdxcXNyc2JyMGZoMw=="} className="btn-link instagram circle"><i className="fa fa-instagram"></i></Link></li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</footer>
		</Fragment >
	)
}

export default Footer;